// extracted by mini-css-extract-plugin
module.exports = {"ball":"loadAnimation_ball__12EQ8","mainContainer":"loadAnimation_mainContainer__3E7kH","rotatingFigs":"loadAnimation_rotatingFigs__39w0w"};